import React from "react";

export default ({ size = "20" }) => {
  const maskId = "greentick" + Math.random();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.98 11.9975C21.98 17.5093 17.5118 21.9775 12 21.9775C6.48822 21.9775 2.02002 17.5093 2.02002 11.9975C2.02002 6.48565 6.48822 2.01746 12 2.01746C17.5118 2.01746 21.98 6.48565 21.98 11.9975ZM6.93092 11.8258C7.2121 11.5446 7.66797 11.5446 7.94915 11.8258L10.2038 14.0805L15.9135 8.37084C16.1946 8.08966 16.6505 8.08966 16.9317 8.37084C17.2129 8.65202 17.2129 9.10789 16.9317 9.38907L10.713 15.6078C10.4318 15.889 9.9759 15.889 9.69472 15.6078L6.93092 12.844C6.64974 12.5628 6.64974 12.107 6.93092 11.8258Z"
        fill="#333333"
      />
      <mask
        id={maskId}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.98 11.9975C21.98 17.5093 17.5118 21.9775 12 21.9775C6.48822 21.9775 2.02002 17.5093 2.02002 11.9975C2.02002 6.48565 6.48822 2.01746 12 2.01746C17.5118 2.01746 21.98 6.48565 21.98 11.9975ZM6.93092 11.8258C7.2121 11.5446 7.66797 11.5446 7.94915 11.8258L10.2038 14.0805L15.9135 8.37084C16.1946 8.08966 16.6505 8.08966 16.9317 8.37084C17.2129 8.65202 17.2129 9.10789 16.9317 9.38907L10.713 15.6078C10.4318 15.889 9.9759 15.889 9.69472 15.6078L6.93092 12.844C6.64974 12.5628 6.64974 12.107 6.93092 11.8258Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <rect width="24" height="24" fill="#428600" />
      </g>
    </svg>
  );
};
